<template>
  <transition name="wsf-modal-fade">
    <div class="wsf-modal-backdrop">
      <div class="wsf-modal" role="dialog">
        <div class="wsf-modal__close">
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            <slot v-if="$slots.closeIcon" name="closeIcon" />
            <span v-else>×</span>
          </button>
        </div>
        <slot name="body"></slot>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'sustainabilitymodal',

  mounted() {
    this.setFocusableElements();
  },

  destroyed() {
    const focusElms = this.$el.querySelectorAll('a, button');
    focusElms.forEach((el) => {
      el.removeEventListener('blur', this.checkFocus);
    });
  },

  methods: {
    close() {
      if (
        document
          .getElementsByTagName('body')[0]
          .classList.contains('dsf-app-fullscreen')
      ) {
        document
          .getElementsByTagName('body')[0]
          .classList.remove('dsf-app-fullscreen');
      }
      this.$emit('close');
    },
    setFocusableElements() {
      const focusElms = this.$el.querySelectorAll('a, button');
      focusElms.forEach((el) => {
        el.classList.add('js-focusable');
        this.closeOnBlur(el);
      });

      setTimeout(() => {
        focusElms[0].focus();
      }, 300);
    },
    isKeyboardUsing() {
      return document.body.classList.contains('is-using-keyboard');
    },
    isFocusableElm() {
      return document.activeElement.classList.contains('js-focusable');
    },
    closeOnBlur(el) {
      el.addEventListener('blur', this.checkFocus);
    },
    checkFocus() {
      setTimeout(() => {
        /* istanbul ignore else */
        if (this.isKeyboardUsing()) {
          if (this.isFocusableElm()) {
            return false;
          } else {
            this.close();
          }
        }
      }, 500);
    },
  },
};
</script>
